/** Menu principal. Cada item pode ser desligado por cliente (features no tenant.json). */
import type { FeatureFlags, Role } from '@dotapps/core';
import type { IconName } from '@dotapps/ui';

export interface NavItem {
  path: string;
  label: string;
  /** rótulo curto da barra do celular */
  short?: string;
  icon: IconName;
  feature?: keyof FeatureFlags;
  /** perfis que veem o item (sem a lista: todos) */
  roles?: Role[];
}

const SELLERS: Role[] = ['admin', 'vendedor'];

export const NAV: NavItem[] = [
  { path: '/', label: 'Painel', icon: 'home' },
  { path: '/cadastros', label: 'Cadastros', icon: 'users', roles: SELLERS },
  {
    path: '/negociacao',
    label: 'Negociação',
    short: 'Funil',
    icon: 'funnel',
    feature: 'negociacao',
    roles: SELLERS,
  },
  { path: '/briefing', label: 'Briefing', icon: 'layers', roles: SELLERS },
  { path: '/agenda', label: 'Agenda', icon: 'cal', feature: 'agenda' },
  { path: '/orcamentos', label: 'Orçamentos', icon: 'calc', feature: 'orcamentos', roles: SELLERS },
  { path: '/propostas', label: 'Propostas', icon: 'doc', feature: 'propostas', roles: SELLERS },
  { path: '/contratos', label: 'Contratos', icon: 'pen', feature: 'contratos', roles: SELLERS },
  { path: '/obras', label: 'Obras', icon: 'gantt', feature: 'obras', roles: SELLERS },
  { path: '/relatorios', label: 'Relatórios', icon: 'chart', feature: 'relatorios', roles: SELLERS },
  { path: '/biblioteca', label: 'Biblioteca', icon: 'book', feature: 'biblioteca', roles: SELLERS },
  { path: '/equipe', label: 'Equipe', icon: 'gear' },
];

/** Itens fixos na barra inferior do celular (o resto fica em "Mais"). */
export const TAB_PATHS = ['/', '/negociacao', '/orcamentos', '/obras'];
/** Barra inferior da projetista (não tem as telas comerciais). */
export const TAB_PATHS_PROJETISTA = ['/', '/agenda', '/equipe'];
export const tabPaths = (role: Role | null) => (role === 'projetista' ? TAB_PATHS_PROJETISTA : TAB_PATHS);

/** Nome do item para o perfil (a projetista recebe os briefings no Painel). */
export const navLabel = (item: NavItem, role: Role | null) =>
  item.path === '/' && role === 'projetista' ? 'Briefing' : item.label;

/** Item liberado para este perfil? */
export const allowed = (item: { roles?: Role[] }, role: Role | null) =>
  !item.roles || (!!role && item.roles.includes(role));

export const isActive = (itemPath: string, pathname: string) =>
  itemPath === '/' ? pathname === '/' : pathname === itemPath || pathname.startsWith(`${itemPath}/`);
